import { Outlet, createFileRoute } from '@tanstack/react-router';
import { CapabilityGate } from '@/components/billing/CapabilityGate';

function InvoicingAreaLayout() {
	return (
		<CapabilityGate capability="sales">
			<Outlet />
		</CapabilityGate>
	);
}

export const Route = createFileRoute('/_authenticated/_app/invoicing')({
	component: InvoicingAreaLayout,
});
